var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.nav),function(item,index){return _c('li',{key:index},[(_vm.showLink(item))?_c('router-link',{class:_vm.linkClasses(item),attrs:{"to":{ name: item.link }}},[_vm._v("\n        "+_vm._s(_vm.$t(item.label))+"\n      ")]):_vm._e()],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f991c7ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DxMobileNav.vue
// module id = null
// module chunks = 